exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@keyframes animatedgradient{}.delete-button-wrapper{border:none;background:rgba(0,0,0,0);box-shadow:none;padding:6px 15px;color:#e02020;font-weight:500;font-size:16px;line-height:19px;font-family:\"Roboto\",sans-serif}.delete-button-wrapper:hover,.delete-button-wrapper:focus{color:#fff;background:#e02020}", ""]);

